import { HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "@environments/environment";

export function headerInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const newReq = req.clone({
    headers: req.headers.set("Ocp-Apim-Subscription-Key", environment.apimSubscriptionKey),
  });
  return next(newReq);
}
